<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%" v-if="!dialogTableVisible">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">商户打卡管理&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>商户打卡列表</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="form.dayStr"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    :clearable="false"
                    @change="onSearch"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="打卡人">
                  <el-input
                    v-model="form.createUserName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="商户名称">
                  <el-input
                    v-model="form.pbmc"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="是否打卡">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasRecordFlag"
                  >
                    <el-option
                      v-for="item in shenheList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否人工审核">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.hasAdminAuditFlag"
                  >
                    <el-option
                      v-for="item in shenheList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属片区">
                  <el-input
                    v-model="form.pian"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="所属社区">
                  <el-select
                    v-model="form.inSqList"
                    multiple
                    collapse-tags
                    filterable
                    placeholder="请选择">
                    <el-option
                      v-for="item in actionsOne"
                      :key="item.deptCode"
                      :label="item.text"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所属联盟">
                  <el-input
                    v-model="form.zu"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn">
              <div class="mr-40" v-for="(item, index) in shanghuCount" :key="index">
                {{ item.label }}：<span class="cl-primary">{{ item.value }}</span>家
              </div>
            </div>
            <div class="right-btn">
              <el-button
                @click="dutyWordExp"
                icon="el-icon-download"
                class="search"
                >导出</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="540"
          >
            <template v-slot:createTime>
              <span>{{ form.dayStr }}</span>
            </template>
            <template v-slot:rangeHourTime="{ scope }">
              <el-tooltip v-if="scope.row.createUserNames" class="item" effect="dark" :content="scope.row.createUserNames" placement="top">
                <span>{{ scope.row.auditCount || 0 }}/<span class="pointer cl-primary">{{ scope.row.taskCount || 0 }}</span> </span>
              </el-tooltip>
              <span v-else>{{ scope.row.auditCount || 0 }}/{{ scope.row.taskCount || 0 }}</span>
            </template>
            <template v-slot:workContent="{ scope }">
              <span>{{ scope.row.auditCount ? '是' : '否' }}</span>
            </template>
            <!-- 智能识别结果 -->
            <template v-slot:zhinshibie="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.aiAuditStates && scope.row.aiAuditStates.split(',')" :key="index" :class="item == '已通过' ? 'pass' : item == '不通过' ? 'noPass' : 'warin'" >{{ item }}</span>
            </template>
            <!-- 标准照片对比结果 -->
             <template v-slot:aiComparisonState="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.aiComparisonState && scope.row.aiComparisonState.split(',')" :key="index" :class="item == '合格' ? 'pass' : item == '不合格' ? 'noPass' : 'warin'" >{{ item.replace('需人工进行二次审核确认', '待人工确认') }}</span>
            </template>
            <!-- 人工审核结果 -->
            <template v-slot:submitFlag="{ scope }">
              <span style="margin-right: 5px;" v-for="(item, index) in scope.row.auditStates && scope.row.auditStates.split(',')" :key="index" :class="item == '已通过' ? 'pass' : item == '不通过' ? 'noPass' : (scope.row.aiComparisonState.split(',')[index] == '合格' || scope.row.aiComparisonState.split(',')[index] == '不合格' ? 'basic' : 'warin')" >{{ scope.row.aiComparisonState.split(',')[index] == '合格' || scope.row.aiComparisonState.split(',')[index] == '不合格' ? '无需审核' : item }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="manualReview(scope.row)"
                style="font-size: 16px"
                type="text"
                >人工审核</el-button
              >
              <el-button
                @click="qusetionDetail(scope.row)"
                style="font-size: 16px"
                type="text"
                >详情</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>
    <detailForm
      v-else
      :item="currentItem"
      :dayStr="form.dayStr"
      :dialogType="dialogType"
      @closeDialog="closeDetail"
    ></detailForm>

    <el-dialog
      title="导出"
      :visible.sync="dialogVisible"
      width="30%">
        <el-date-picker
          v-model="date"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 400px !important"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="dialogLoading" @click="exportTaskInfo">确 定</el-button>
      </span>
    </el-dialog>
    
  </div>
</template>

<script>
import {
  exportTaskInfo,
  byShanghuAnisPage,
  shanghuSubmitCount,
} from "@/api/task.js";
import {
  getCommcommunityAll,
} from "@/api/point.js";
import commonTable from "@/components/table/index.vue";
import moment from "moment";
import detailForm from "./detailForm.vue";
export default {
  components: {
    detailForm,
    commonTable
  },
  data() {
    return {
      dialogVisible: false,
      date: [],
      dialogLoading: false,
      loading: false,
      actionsOne: [],
      dialogTableVisible: false,
      currentItem: {},
      dialogVisible2: false,
      exportLoading: false,
      exportForm: {
        createTimeEnd: "",
        createTimeStart: "",
        searchSource: "",
        valueTime: [],
        eventType: "",
        state: ""
      },
      actionsTwo: [],
      form: {
        createUserName: "",
        pbmc: "",
        pian: "",
        inSqList: [],
        zu: "",
        dayStr: moment(new Date()).format("YYYY-MM-DD"),
        hasRecordFlag: '',
        hasAdminAuditFlag: ''
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "pbmc",
            label: "商户名称"
          },
          {
            prop: "pian",
            label: "所属片区"
          },
          {
            prop: "sq",
            label: "所属社区"
          },
          {
            prop: "zu",
            label: "所属联盟"
          },
          {
            slot: "createTime",
            label: "日期",
          },
          {
            slot: "rangeHourTime",
            label: "人工审核次数/打卡次数"
          },
          {
            slot: "workContent",
            label: "是否人工审核"
          },
          {
            slot: "zhinshibie",
            label: "智能识别结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "aiComparisonState",
            label: "标准照片对比结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "submitFlag",
            label: "人工审核结果",
            width: "200px",
            showToolitip: '1'
          },
          {
            slot: "operation",
            label: "操作",
            width: "200px"
          }
        ]
      },
      exportLoading: false,
      // 审核结果
      auditStateList: [
        {
          value: "待审核",
          text: "待审核"
        },
        {
          value: "审核通过",
          text: "审核通过"
        },
        {
          value: "审核不通过",
          text: "审核不通过"
        }
      ],
      // 是否人工审核
      shenheList: [
        {
          value: '是',
          text: "是"
        },
        {
          value: '否',
          text: "否"
        }
      ],
      // 审核/详情
      dialogType: "",
      shanghuCount: []
    };
  },
  async mounted() {
    await this.getmySqDept();
    await this.getPointTypeListPageFun();
    this.getShanghuCount();
  },
  methods: {
    closeDetail () {
      this.dialogTableVisible = false;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    // 人工审核
    manualReview(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "审核";
      this.currentItem.fileJson = [
        {
          url:
            "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
        },
        {
          url:
            "https://gxai.bjhddsj.cn/zgc-api-gw/gh-app-server/file/download?filePath=imgPic/1756459242131_b5834485.jpg"
        }
      ];
    },
    // 详情
    qusetionDetail(row) {
      this.currentItem = row;
      this.dialogTableVisible = true;
      this.dialogType = "详情";
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
      this.getShanghuCount();
    },
    onReset() {
      this.form.createUserName = '';
      this.form.pbmc = '';
      this.form.pian = '';
      this.form.inSqList = [];
      this.form.zu = '';
      this.form.dayStr = moment(new Date()).format("YYYY-MM-DD");
      this.page.page = 1;
      this.page.size = 10;
      this.form.hasRecordFlag = '';
      this.form.hasAdminAuditFlag = '';
      this.getPointTypeListPageFun();
    },
    // 社区数据
    async getmySqDept (inSqList = '') {
      let res = await getCommcommunityAll();
      if (res.data.code == 200) {
        let actionsData = res.data.data.map((item) => ({
						value: item.pointName,
						text: item.pointName,
						deptCode: item.deptCode,
					}));
					let depcode = JSON.parse(
						sessionStorage.getItem("userInfo")
					).detpCode;
					// let depcode = "4403260050232323";
					this.form.inSqList = [];
					if (depcode.length < 12) {
						this.actionsOne = JSON.parse(JSON.stringify(actionsData));
					} else {
						let code = depcode.slice(0, 12);
						this.actionsOne = actionsData.filter(
							(item) => item.deptCode == code
						);
						if (this.actionsOne.length) {
							this.form.inSqList.push(this.actionsOne[0].value)
              this.form.sq = this.actionsOne[0].value;
						}
            else {
							this.actionsOne = JSON.parse(JSON.stringify(actionsData));
						}
					}
      }
    },
    dutyWordExp () {
      this.dialogVisible = true;
      this.date = [];
    },
    // 导出
    async exportTaskInfo() {
      if (!this.date.length) return this.$message.error('请选择时间');
      this.dialogLoading = true;
      let res = await exportTaskInfo({
        startTime: this.date && this.date.length ? this.date[0] : '',
        endTime: this.date && this.date.length ? this.date[1] : '',
        ...this.form,
      });
      if (res.status == 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "商户打卡列表" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        this.dialogVisible = false;
        this.$message.success('操作成功');
      }
      this.dialogLoading = false;
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await byShanghuAnisPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data ? (res.data.data.records
          ? res.data.data.records
          : []) : [];
        this.page.total = res.data ? res.data.data.total : 0;
      } else return this.$message.error(res.data.msg)
    },

    // 查询商户提交情况（后台列表统计）
    async getShanghuCount() {
      if (!this.form.dayStr) return false;
      let params = {
        dayStr: this.form.dayStr,
      };
      const res = await shanghuSubmitCount(params);
      if (res.data.code == 200) {
        this.shanghuCount = res.data.data;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";
.cl-primary {
  color: #008cff;
}
.mr-40 {
  margin-right: 40px;
}
.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
.pass {
  color: #17b3ad;
}
.noPass {
  color: #ff5348;
}
.warin {
  color: #FFA200;
}
.basic {
  color: #909399;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/shClockList/index.vue